import { computed, ref, unref } from 'vue';
import { FrillWidget, initialise } from './frill';

type Configuration = { key: string; widgetKey: string };

let configuration: Configuration | undefined;
let instance: Promise<FrillWidget> | undefined;

const ready = ref(false);
const announcementCount = ref(0);

// called once to initialise the announcements
export function configureAnnouncements(options: Configuration): void {
  configuration = options;
}

export function useAnnouncements() {
  if (!instance && configuration) {
    instance = initialise(configuration.key, configuration.widgetKey, ({ count }) => {
      if (typeof count === 'number') {
        announcementCount.value = count;
      }
    });
    instance.then(() => (ready.value = true));
  }

  async function identify(options: { displayName: string; email: string }) {
    (await instance)?.identify({ email: options.email, name: options.displayName });
  }

  async function toggle() {
    (await instance)?.open();
  }

  async function setTheme(theme: 'light' | 'dark') {
    (await instance)?.updateSettings({ appearance: { theme: { idx: theme } } });
  }

  return {
    ready: computed(() => unref(ready)),
    count: computed(() => unref(announcementCount)),
    identify,
    toggle,
    setTheme,
  };
}
